// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warning-banner__wrapper[data-v-97aa2f3c] {\n  position: relative;\n  margin: 1rem 0;\n  padding: 12px;\n  border-radius: 3px;\n  background-color: #ffb6c7;\n  color: #f04;\n  font-size: 13px;\n}\n.warning-banner__message[data-v-97aa2f3c] {\n  margin-bottom: 10px;\n}\n.warning-banner__checkbox[data-v-97aa2f3c] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
